module.exports = __webpack_public_path__ + "static/media/blog14right.03476dfb.jpg";